// import clone from 'lodash/clone'

const storageImplKey = localStorage.getItem('mock.storageImpl') || 'localStorage'
const storageImpl = window[storageImplKey]

const getScenarios = () => {
  if (window.mock && window.mock.temp) {
    return window.mock.scenarios
  } else {
    return JSON.parse(storageImpl.getItem('mock.scenarios') || '[]')
  }
}

function setMockConfig () {
  window.addScenarios = async (bundles, scenariosToAdd, scenariosToRemove) => {
    const scenarios = !bundles && !scenariosToAdd ? getScenarios() : scenariosToAdd
    if (bundles && !Array.isArray(bundles)) {
      bundles = [bundles]
    }

    if (scenariosToAdd && !Array.isArray(scenariosToAdd)) {
      scenariosToAdd = [scenariosToAdd]
    }

    if (scenariosToRemove && !Array.isArray(scenariosToRemove)) {
      scenariosToRemove = [scenariosToRemove]
    }

    const payload = { bundles, scenariosToAdd: scenarios, scenariosToDelete: scenariosToRemove }

    await fetch('/__publicPath__/mock',
      {
        method: 'DELETE'
      })

    const appliedScenarios = await fetch('/__publicPath__/mock/scenario',
      {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(payload)
      }).then((response) => response.json())

    const storageScnearios = appliedScenarios.map(function (ac) {
      return ac.id
    })
    storageImpl.setItem('mock.scenarios', JSON.stringify(storageScnearios))
    return appliedScenarios
  }
}

export { setMockConfig }
